import React from "react";
import { Card } from "antd";
import { CDBIcon } from "cdbreact";

export const ApprovedCard = ({ totalVentasPagina, showApproved, setShowApproved }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', gap: '50px', paddingLeft: '30px' }}>
      <Card style={{ width: 500, background: showApproved ? '#D9FFD5' : '#9A9A9A', color: showApproved ? '#3E3E3E' : '#FFFFFF', border: showApproved ? '1px solid #0E9600' : '1px solid #9A9A9A', position: 'relative', transition: 'background-color 0.3s', fontFamily: 'Montserrat, sans-serif' }}>
        <div style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }} onClick={() => setShowApproved(!showApproved)}>
          {showApproved ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
        </div>
        <div style={{ marginTop: '10px' }}>
          <p style={{ textAlign: 'left' }} className="fw-bold h4  align-self-start">
            {showApproved ? totalVentasPagina.toLocaleString("es-MX", { style: "currency", currency: "MXN" }) : '******'}
          </p>
        </div>
        <p style={{ textAlign: 'left' }} className="fw-bold h5">Total Aprobado (Mes actual)</p>
      </Card>
    </div>
  );
};